import { shipstationGetQuery, shipstationCreateReturnLabelForShopifyOrder } from '../../api/orders/shipstation';
import { SET_ORDER } from '../../constants/shipstation';
import { extractSelectedTicketFromState } from '../../extractFromState';

export const setShipstationSelectOrder = (selectedOrder) => ({
  type: SET_ORDER,
  selectedOrder,
});

/**
 * Get order details from ship station
 * @param {string} simplrAccountId
 * @param {string} shopName
 * @param {string} orderNumber
 * @return {Function}
 */
export const getShipstationOrder =
  ({ simplrAccountId, shopName, orderNumber }) =>
  async (dispatch) => {
    const query = {
      simplrAccountId,
      shopName,
      orderNumber,
    };
    try {
      const order = await shipstationGetQuery('/getOrder', query);
      dispatch(setShipstationSelectOrder(order));
    } catch (error) {}
  };

/**
 * Lists shops that integrated through shipstation
 * @return {Function}
 */
export const loadShipstationShops = () => async (dispatch, getState) => {
  const selectedTicket = extractSelectedTicketFromState(getState());
  if (!selectedTicket) {
    return [];
  }

  const query = {
    simplrAccountId: selectedTicket.simplrAccountPtrId,
  };

  return await shipstationGetQuery('/listShopIntegrations', query);
};

/**
 * Create Return label via ship station for shopify order
 * @param {string} simplrAccountId
 * @param {string} shopName
 * @param {string} orderNumber
 * @return {Function}
 */
export const createShipstationReturnLabel =
  ({ simplrAccountId, shopName, orderNumber }) =>
  async () => {
    const payload = {
      simplrAccountId,
      shopName,
      orderNumber,
    };

    return await shipstationCreateReturnLabelForShopifyOrder('/createReturnLabel', payload);
  };
